import { render, staticRenderFns } from "./ClaimDocumentList.vue?vue&type=template&id=09b2cf58&"
import script from "./ClaimDocumentList.vue?vue&type=script&lang=js&"
export * from "./ClaimDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports